'use client';

import React, { JSX } from 'react';

import useCart from '@/hooks/useCart';
import useCheckout from '@/hooks/useCheckout';

import CartApplyCoupon from '@/components/Cart/blocks/CartApplyCoupon';
import LoadingIcon from '@/components/Icons/LoadingIcon';

import TotalsTable from './TotalsTable';
import {
	buildBuylistCheckoutRows,
	buildSaleCheckoutRows,
} from './totalsRows';

import styles from './_styles/Totals.module.scss';


// Prop types
interface CheckoutTotalsProps {
	isBuylist?: boolean;
	cartLoading?: boolean;
	className?: string;
	showCouponEntry?: boolean;
}


// Totals of the cart being checked out (sale or buylist)
export const CheckoutTotals = (props: CheckoutTotalsProps): JSX.Element => {

	// Props
	const {
		isBuylist = false,
		cartLoading = false,
		className,
		showCouponEntry = true,
	} = props;

	// Accessing Redux state
	const {
		activeCart,
		activeBuylistCart,
		storeCreditPricing,
	} = useCart();

	const { checkoutSession } = useCheckout();

	// Methods
	const getRows = () => {
		if(isBuylist) {
			return activeBuylistCart ? buildBuylistCheckoutRows(activeBuylistCart, storeCreditPricing) : null;
		}
		return activeCart ? buildSaleCheckoutRows(activeCart, checkoutSession) : null;
	};

	// Render
	const rows = getRows();
	if(!rows) {
		return cartLoading ? (
			<div className={`${styles.Totals} ${className || ''}`}>
				<LoadingIcon />
			</div>
		) : <></>;
	}

	// Coupon entry sits under the coupon line, or the subtotal before one is applied; buylists take no coupons
	return (
		<TotalsTable
			rows={rows}
			className={className}
			slot={(!isBuylist && showCouponEntry) ? <CartApplyCoupon /> : null}
			slotAfterKey={rows.some((row) => row.key === 'coupon') ? 'coupon' : 'subtotal'} />
	);
};

export default CheckoutTotals;
